/* globals $: true, Codsec: true*/

this.Codsec = this.Codsec || {};

this.Codsec.userSettings = {
	init : function() {
		$('#subaccount-container').on('click', '#subaccount-add-button', function(e) {
			e.preventDefault();

			executePost('/user/subaccounts', {
				email : $('#subaccount-invite-email-input').val()
			})
			.done(function(subaccounts) {
				$('#subaccount-container').html(Codsec.templates.dashboard.subaccounts({
					subaccounts : subaccounts
				}));
			})
			.fail(function(error) {
				$('#subaccount-add-error').text(error.responseJSON.message);
				$('#subaccount-add-error').show();
			});
		});

		$('#subaccount-container').on('click', '.subaccount-delete-button', function(e) {
			e.preventDefault();
			executeDelete('/user/subaccounts', {
				email : $(this).data('email')
			})
			.done(function(subaccounts) {
				$('#subaccount-container').html(Codsec.templates.dashboard.subaccounts({
					subaccounts : subaccounts
				}));
			})
			.fail(function() {
				window.location = '/problem';
			});
		});

		$('#change-password-button').on('click', function(e) {
			e.preventDefault();

			window.location = '/password-change';
		});

		$('#ignored-libraries-container').on('click', '.ignored-libraries-remove', function(e) {
			e.preventDefault();

			$(this).closest('li').remove();
		});

		$('#add-more-scans-button').on('click', function(e) {
			e.preventDefault();

			$('#add-scans-first-step').hide();
			$('#add-scans-second-step').show();
		});
	}
};
